<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Login Attempts</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search }
      </button>
    </div>
  </div>
  <app-login-attempt-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (loginAttemptSearchFilter)="onSearchFilterChange($event)">
  </app-login-attempt-search-box>
  <app-generic-list
    [items]="loginAttempts"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [currentPage]="currentPage - 1"
    (itemClick)="onItemClick($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)">
  </app-generic-list>
</div>
